import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/asymmetrik': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M517.5 309.2c-13.9 14.3-30.4 27.7-48.9 39.8l73.4 110.4h-101.6l-45.9-71.8c-17.6 7.2-35.9 13.4-54.5 18.7l32.6 53.1h-135.5l22.8-37.1c-23.3 2.7-46.4 3.7-68.6 2.7l-22 34.4h-101.6l34.5-51.7c-45-17.9-68.9-47.9-68.4-83 0.3-25.8 14-54.3 41.7-82.9 38.9-40 96.5-72.6 161.6-92.9-22.3 8.1-42 18.5-62 30.7-31.2 16.2-58.7 35.9-79.5 58.1-57.4 61-46.5 121.8 19.1 151.2l190.2-285.5 150.9 226.4c13-9.5 24.8-19.8 35-30.6 98-104.2 53.7-207.9-98.8-231.7-68.3-10.6-146.8-5.7-221.3 14.8-60.1 10-118.7 31.7-170.7 58.2 118.1-66.9 277.9-102.1 406.6-82.4 110 16.8 170.2 69.5 169.4 135-0.4 36.1-19.7 76.1-58.5 116.1zM329.9 389.7c18.4-5.3 36.5-11.8 53.7-19.2l-78.7-123-101.9 159.3c22.5 0.7 45.8-0.9 69.2-4.4l32.7-53.3z'
      }
    ]
  }
})
